import { api } from "./client";

export type AdminUserRow = {
  id: number;
  email: string;
  name: string;
  department: string | null;
  role: "ADMIN" | "MANAGER" | "VIEWER";
  status: "PENDING" | "APPROVED" | "REJECTED";
  scoped_departments: string[];
  approved_at: string | null;
  created_at: string;
};

export type UpdateUserAction =
  | { action: "approve" }
  | { action: "reject" }
  | { action: "update_role"; role: "ADMIN" | "MANAGER" | "VIEWER" }
  | { action: "update_scope"; scoped_departments: string[] };

export const adminApi = {
  listUsers: () => api.get<AdminUserRow[]>("/admin/users"),
  updateUser: (id: number, body: UpdateUserAction) =>
    api.patch<{ ok: boolean }>(`/admin/users/${id}`, body),
};
